import React from "react"
import Form from "../../components/Form"
import FormField from "../../components/FormField"

import {isValidZipCode} from "../../utils/formValidationUtils"
import {matchIsValidTel} from 'mui-tel-input'

import {bindActionCreators} from "redux";
import * as actions from "../../actions"
import {connect} from "react-redux"

import {capitalizeAllWords} from "../../utils/stringUtils"
import {DOMINICA_COUNTRY_ID, USA_COUNTRY_ID} from "../../constants/country"

class PayeeAddressForm extends Form {

    constructor(props){
        super(props)
        let contactNumber = ""
        let countryId = this.fields.countryId
        if (props.address){
            if (props.address.contactNumber && typeof props.address.contactNumber === 'string') {
                contactNumber = props.address.contactNumber
            }     
            if (props.address.countryId) countryId = props.address.countryId 
        } 
        this.state = {
            values: {...this.fields, ...props.address, contactNumber, countryId},
            errors: {},
            labels: {
                ...this.defaultLabels,
                ...props.labels
            },
            settlements: this.getSettlements(countryId),
            allowedCountryList: []
        }
        
    }

    defaultLabels = {
        line1: "Line 1",
        line2: "Line 2",
        countryId: "Country",
        settlementId: "Town",
        directions: "Directions",
        usaCity: "City",
        zipCode: "Zipcode",
        contactNumber: "Contact number",
        name: "Location name"
    }
    static defaultProps = {
        address: {},
        labels: {},
        allowChangeCountry: true,
        allowedCountryIds: [DOMINICA_COUNTRY_ID],
        formTitle: "Address Form",
        buttonText: "Submit",
        submit: () => {},
        postSubmit: () => {}
    }

    fields = {
        line1: "",
        line2: "",
        city: "",
        settlementId:"",
        countryId: DOMINICA_COUNTRY_ID,
        contactNumber: "",
        directions: "",
        zipCode:"",
        usaCity: "",
        name: ""
    }

    identifier = 'line1'

    loadAllowedCountries = async () => {
        // Load the countries the payee is allowed to select from
        const { actions, countries, allowedCountryIds } = this.props;
    
        const missingCountryIds = allowedCountryIds
            .filter(countryId => countryId && !countries.countriesById[countryId]);
    
        await Promise.all(
            missingCountryIds.map(countryId => actions.httpFetchSaveCountry(countryId))
        );
    
        // Safely extract the country objects after fetch
        const allowedCountryList = allowedCountryIds
            .map(countryId => {
                const country = countries.countriesById[countryId]
                if (!country) return
                else return {
                    ...country,
                    name: capitalizeAllWords(country.name)
                }
            })
            .filter(Boolean); // Remove any null/undefined values
    
        this.setState({ allowedCountryList });
    };

    componentDidMount(){
        this.loadAllowedCountries()
    }

    componentDidUpdate(prevProps) {
        //if a country was selected but was not loaded, load it's settlements after loading
        const {countryId} = this.state.values
        if (
            !prevProps.countries.countriesById[countryId] && //was not loaded
            this.props.countries.countriesById[countryId] //is loaded
        ){
            this.setState({
                settlements: this.getSettlements(countryId)
            })
        }
    }

    getSettlements = countryId => {
        const {countries} = this.props 
        const country = countries.countriesById[countryId]
        if (!country) {
            return []
        } 
        return Object.keys(country.settlements)
                    .map(settlementId => ({
                            id: settlementId,
                            name: capitalizeAllWords(country.settlements[settlementId])
                        }))
                        .sort((a,b) =>{
                            if ( a.name < b.name ){
                                return -1;
                                }
                                if ( a.name > b.name ){
                                return 1;
                                }
                                return 0;
                        })
    }

    executeSubmit = async () => {
        let {submit, countries} = this.props
        const {line1, line2,city, settlementId, countryId, contactNumber,directions, usaCity, zipCode, name}= this.state.values
        const country = countries.countriesById[countryId]
        return await submit(
            {
                line1: line1.trim(),
                line2: line2.trim(),
                city: city.toLowerCase(),
                settlementId,
                countryName: country.name,
                countryId,
                contactNumber,
                directions: directions.trim(),
                usaCity: usaCity.toLowerCase().trim(),
                zipCode: zipCode.trim(),
                name: name.trim()
            },
            this.handleSubmitSuccess, 
            this.handleSubmitError
        )
    }

    validate = () => {
        const errors = {}
        const {values} = this.state
        const {line1, line2,city, countryId, contactNumber, directions, zipCode} = values

        Object.keys(values).forEach(key => {
            if (!Boolean(values[key]) &&
                (key !== "line2") &&
                (key !== "directions") &&
                (key !== "line1") &&
                //usa specific address params
                (!((countryId !== USA_COUNTRY_ID) && (key === "zipCode"))) &&
                (!((countryId !== USA_COUNTRY_ID) && (key === "usaCity")))
            ){
                const label = key === 'countryId'? "country" 
                            : key === "contactNumber" ? "phone number" 
                            : key === "settlementId" ? `${countryId === USA_COUNTRY_ID ? 'state' : 'town or village'}` 
                            : key === "city" ? "town/village/capital" : key
                errors[key] = `${label} is required`
            }
        })
        if (!errors["contactNumber"] &&
            (!contactNumber || !matchIsValidTel(contactNumber))
        )  errors["contactNumber"] = "Please provide a valid phone number"
        if ((countryId === USA_COUNTRY_ID) && !errors["zipCode"] && !isValidZipCode(zipCode)) errors["zipCode"] = "zip code must be in the format 12345 or 12345-5555"
        if (!line1.trim() && !directions.trim()){
            errors["line1"] =`must provide a street address${countryId === DOMINICA_COUNTRY_ID? ' or directions' : ""}`
            errors["directions"] = `must provide a street address${countryId === DOMINICA_COUNTRY_ID? ' or directions' : ""}`
        }
        if (Object.values(errors).every(error => !error)) return true
        else {
            this.setState({errors})
            return false
        }
    }

    handleSubmitSuccess = () => {
        const {postSubmit} = this.props
        if (postSubmit) postSubmit()
    }
    handleSubmitError = (object) => {
        const errors = {}
        errors["createAddress"] = `Failed to create address`
        this.setState({errors})
    }

    clearFields = () => {
        this.setState({
            values: {...this.fields},
            settlements: this.getSettlements(this.fields.countryId)
        })
    }

    handleChangeCountry = countryId => {
        this.setState({
            values: {
                ...this.state.values,
                countryId,
                settlementId: "",
                city: "",
                usaCity:"",
                zipCode: "",
            },
            errors: {},
            settlements: this.getSettlements(countryId)
        })
    }

    handleChangeSettlement = settlementId => {
        const {values} = this.state
        const {countries} = this.props
        if (!values.countryId) return
        const city = countries.countriesById[values.countryId].settlements[settlementId]
        this.setState({
            values: {
                ...values,
                settlementId,
                city,
            },
            errors: {}
        })
    }

    render(){
        const {values, errors, labels, settlements, allowedCountryList} = this.state
        const {line1, line2, city, directions, countryId, contactNumber, settlementId, zipCode, usaCity, name:locationName} = values
        const {formTitle, buttonText, countries} = this.props
        
        return (
            <div className="text-align-left formContainer">
                <div className="formHeader">
                    <div className={"h2 text-align-center"}>{formTitle}</div>
                </div>
                <div className="formBody">
                    <FormField 
                        label={labels.countryId} 
                        type="select"
                        value={countryId} 
                        dataArray={allowedCountryList}
                        onChange={this.handleChangeCountry}
                        errorText={errors.countryId}
                    />
                    <FormField 
                        label={labels.settlementId} 
                        type="select"
                        value={settlementId} 
                        dataArray={settlements}
                        onChange={this.handleChangeSettlement}
                        errorText={errors.settlementId}
                    />
                    <FormField 
                        label={labels.line1} 
                        value={line1} 
                        onChange={e => this.handleChange(e, 'line1')}
                        onKeyDown={this.handleKeyDown}
                        errorText={errors.line1}
                        placeholder="e.g. 61 Hillsborough St, skip if none"
                    />
                    <FormField 
                        label={labels.line2}
                        value={line2} 
                        onChange={e => this.handleChange(e, 'line2')}
                        onKeyDown={this.handleKeyDown}
                        errorText={errors.line2}
                        placeholder="e.g. Flat 5 or 4th Floor or Fire Station, skip if none"
                    />
                    { 
                        countryId === DOMINICA_COUNTRY_ID ?
                        <FormField 
                            label={labels.directions}
                            value={directions} 
                            type="textarea"
                            onChange={e => this.handleChange(e, 'directions')}
                            errorText={errors.directions}
                            placeholder="e.g. take the first left after the fire station, third house on your right"
                        />
                        :
                        null
                    }
                    
                    { 
                        countryId === USA_COUNTRY_ID ?
                        <React.Fragment>
                            <FormField 
                                label={labels.usaCity}
                                value={usaCity} 
                                onChange={e => this.handleChange(e, 'usaCity')}
                                errorText={errors.usaCity}
                            />
                            <FormField 
                                label={labels.zipCode}
                                value={zipCode} 
                                onChange={e => this.handleChange(e, 'zipCode')}
                                errorText={errors.zipCode}
                            />
                        </React.Fragment>
                        :
                        null
                    }
                    <FormField 
                        label={labels.contactNumber}
                        type="tel" 
                        value={contactNumber} 
                        onChange={contactNumber => this.handleChangeSelect(contactNumber, "contactNumber")}
                        onKeyDown={this.handleKeyDown}
                        errorText={errors.contactNumber}
                    />
                    <FormField 
                        label={labels.name} 
                        value={locationName} 
                        onChange={e => this.handleChange(e, 'name')}
                        onKeyDown={this.handleKeyDown}
                        errorText={errors.name}
                    />
                </div>
                <div className="formFooter">
                    <button className="button secondary width-100pct" onClick={this.handleSubmit}>{buttonText}</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    countries: state.countries
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(PayeeAddressForm)